const styles = theme => ({
	signOutBtn: {
		position: "absolute",
		bottom: "0px",
		left: "0px",
		width: "300px",
		borderRadius: "0px",
		backgroundColor: "#227092",
		height: "35px",
		boxShadow: "0px 0px 2px black",
		color: "white"
	},
	profileBtn: {
		position: "absolute",
		bottom: "35px",
		left: "0px",
		width: "300px",
		borderRadius: "0px",
		backgroundColor: "#321913",
		height: "35px",
		boxShadow: "0px 0px 2px black",
		color: "white"
	},
	aboutBtn: {
		position: "absolute",
		bottom: "140px",
		left: "0px",
		width: "300px",
		borderRadius: "0px",
		backgroundColor: "#192",
		height: "35px",
		boxShadow: "0px 0px 2px black",
		color: "white"
	},
	friendsBtn: {
		position: "absolute",
		bottom: "70px",
		left: "0px",
		width: "300px",
		borderRadius: "0px",
		backgroundColor: "#FFA500",
		height: "35px",
		boxShadow: "0px 0px 2px black",
		color: "white"
	},
	whiteboardBtn: {
		position: "absolute",
		bottom: "105px",
		left: "0px",
		width: "300px",
		borderRadius: "0px",
		backgroundColor: "#273c75",
		height: "35px",
		boxShadow: "0px 0px 2px black",
		color: "white"
	}
});

export default styles;
